import TbhLogoWithText from '../common/TbhLogoWithText';
import ComingSoonC from '../components/ComingSoon';

const ComingSoon = () => {
  return (
    <div className='loginContainer h-screen'>
      <div className='logoContainer pt-[32px]'>
        <TbhLogoWithText width={'102px'} height={'32px'} />
      </div>
      <ComingSoonC />
    </div>
  );
};

export default ComingSoon;
